import { api } from '../client';
import type { Client } from '../../types/client';

export interface MonitoringResponse {
  success: boolean;
  clients: Client[];
  summary: {
    total: number;
    healthy: number;
    degraded: number;
    down: number;
    noMetrics: number;
    avgCpu: number;
    avgMemory: number;
    avgDisk: number;
  };
}

export const monitoringApi = {
  overview: (params: { page?: number; limit?: number; search?: string; health?: string } = {}) =>
    api.get<MonitoringResponse>('/api/monitoring', params as Record<string, string | number>),
};
